// extracted by mini-css-extract-plugin
export default {"starLeft":"XYJFHz","animated":"ntrjdS","starLeftAnimation":"iP7evV","starRight":"B2emRM","starRightAnimation":"wgEKKk"};